<template>
    <div>
        <el-dialog title="操作记录" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <div>
                <recordList ref="recordRef" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import recordList from '../../components/OperateRecordList.vue'
export default {
    name: 'operateRecord',
    components: { recordList },
    props: {},
    data() {
        return {
            dialogVisible: false,
        }
    },
    methods: {
        init(id) {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs['recordRef'].init({ id })
            })
        },
        handleClose() {
            this.dialogVisible = false
        },
    },
}
</script>
<style lang="less" scoped>
.page-group {
    text-align: right;
    margin-top: 20px;
}
</style>
